import { EXPERIMENTS, getAssignedExperimentBucket } from '@src/experiments'
import { isEmpty } from '@src/utils/functions/utils'

import QuinceApiError from '../../domains/quince-api-error'
import { storefrontRuntimeHttpClient } from '../../utils/HttpClient'

class GiftService {
  public async getGiftEligibleVariantIds(variantIds: number[], location: string): Promise<number[]> {
    const freeToteExperimentBucket = getAssignedExperimentBucket(EXPERIMENTS.FREE_TOTE.experimentName)
    const isControlBucket = freeToteExperimentBucket !== EXPERIMENTS.FREE_TOTE.bucketNames.show

    if (isControlBucket || isEmpty(variantIds)) {
      return []
    }

    try {
      const { data: eligibleVariantIds } = await storefrontRuntimeHttpClient.get<string[]>(
        '/check-location-availability',
        {
          params: {
            variantIds: variantIds.join(','),
            location,
          },
        },
      )
      return eligibleVariantIds.map(variantId => Number(variantId))
    } catch (e) {
      throw new QuinceApiError({
        error: e as Error,
        // @i18n-ignore
        message: 'Failed while fetching free gift eligible products',
        apiName: 'CHECK_LOCATION_AVAILABLILTY',
      })
    }
  }
}

const giftService = new GiftService()

export default giftService
